/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { CreateDiscreteTextValueListDto } from './CreateDiscreteTextValueListDto';
import {
    instanceOfCreateDiscreteTextValueListDto,
    CreateDiscreteTextValueListDtoFromJSON,
    CreateDiscreteTextValueListDtoFromJSONTyped,
    CreateDiscreteTextValueListDtoToJSON,
} from './CreateDiscreteTextValueListDto';
import type { CreateEnumerationValueListDto } from './CreateEnumerationValueListDto';
import {
    instanceOfCreateEnumerationValueListDto,
    CreateEnumerationValueListDtoFromJSON,
    CreateEnumerationValueListDtoFromJSONTyped,
    CreateEnumerationValueListDtoToJSON,
} from './CreateEnumerationValueListDto';
import type { CreateNumericDataSetFilterDto } from './CreateNumericDataSetFilterDto';
import {
    instanceOfCreateNumericDataSetFilterDto,
    CreateNumericDataSetFilterDtoFromJSON,
    CreateNumericDataSetFilterDtoFromJSONTyped,
    CreateNumericDataSetFilterDtoToJSON,
} from './CreateNumericDataSetFilterDto';

/**
 * @type ICreateSetupParameterFilter
 * 
 * @export
 */
export type ICreateSetupParameterFilter = { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.EnumerationDto.CreateEnumerationValueListDto, Ptw.Ptw100.AppZero.Application.Shared' } & CreateEnumerationValueListDto | { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.Results.Dto.CreateNumericDataSetFilterDto, Ptw.Ptw100.AppZero.Application.Shared' } & CreateNumericDataSetFilterDto | { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.SystemSetupParameters.CreateDiscreteTextValueListDto, Ptw.Ptw100.AppZero.Application.Shared' } & CreateDiscreteTextValueListDto;


export function ICreateSetupParameterFilterFromJSON(json: any): ICreateSetupParameterFilter {
    return ICreateSetupParameterFilterFromJSONTyped(json, false);
}

export function ICreateSetupParameterFilterFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICreateSetupParameterFilter {
    if (json == null) {
        return json;
    }
    switch (json['$type']) {
        case 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.EnumerationDto.CreateEnumerationValueListDto, Ptw.Ptw100.AppZero.Application.Shared':
            return Object.assign({}, CreateEnumerationValueListDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.EnumerationDto.CreateEnumerationValueListDto, Ptw.Ptw100.AppZero.Application.Shared' } as const);
        case 'Ptw.Ptw100.AppZero.Application.Shared.Results.Dto.CreateNumericDataSetFilterDto, Ptw.Ptw100.AppZero.Application.Shared':
            return Object.assign({}, CreateNumericDataSetFilterDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Application.Shared.Results.Dto.CreateNumericDataSetFilterDto, Ptw.Ptw100.AppZero.Application.Shared' } as const);
        case 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.SystemSetupParameters.CreateDiscreteTextValueListDto, Ptw.Ptw100.AppZero.Application.Shared':
            return Object.assign({}, CreateDiscreteTextValueListDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.SystemSetupParameters.CreateDiscreteTextValueListDto, Ptw.Ptw100.AppZero.Application.Shared' } as const);
        default:
            throw new Error(`No variant of ICreateSetupParameterFilter exists with '$type=${json['$type']}'`);
    }
}

export function ICreateSetupParameterFilterToJSON(value?: ICreateSetupParameterFilter | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    switch (value['$type']) {
        case 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.EnumerationDto.CreateEnumerationValueListDto, Ptw.Ptw100.AppZero.Application.Shared':
            return CreateEnumerationValueListDtoToJSON(value);
        case 'Ptw.Ptw100.AppZero.Application.Shared.Results.Dto.CreateNumericDataSetFilterDto, Ptw.Ptw100.AppZero.Application.Shared':
            return CreateNumericDataSetFilterDtoToJSON(value);
        case 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.SystemSetupParameters.CreateDiscreteTextValueListDto, Ptw.Ptw100.AppZero.Application.Shared':
            return CreateDiscreteTextValueListDtoToJSON(value);
        default:
            throw new Error(`No variant of ICreateSetupParameterFilter exists with '$type=${value['$type']}'`);
    }

}

/**
 * Check if a given object implements the ICreateSetupParameterFilter interface.
 */
export function instanceOfICreateSetupParameterFilter(value: any): value is ICreateSetupParameterFilter {
    if (instanceOfCreateEnumerationValueListDto(value)) return true;
    if (instanceOfCreateNumericDataSetFilterDto(value)) return true;
    if (instanceOfCreateDiscreteTextValueListDto(value)) return true;
    return false;
}

